
export const WALLET_RULE_KIND = ['payin', 'payout'];

